import { useMemo, useState } from "react";
import { inputClass } from "@/components/common/surfaceClasses";
import {
  filterQualityIssues,
  qualityIssueLabel,
  uniqueSorted,
  type QualityPageSize,
} from "@/components/audience-data/audienceDataFormat";
import { AudienceDataQualityIssues } from "@/components/audience-data/AudienceDataQualityIssues";
import type { SsdQualityIssue } from "@/lib/ssdSalesClient";

export function AudienceDataUnmatchablePanel(props: { issues: SsdQualityIssue[] }) {
  const [issueType, setIssueType] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<QualityPageSize>(10);
  const types = useMemo(() => uniqueSorted(props.issues.map((i) => i.issue_type)), [props.issues]);
  const filtered = useMemo(
    () => filterQualityIssues(props.issues, issueType),
    [props.issues, issueType]
  );

  return (
    <div className="min-w-0 space-y-3">
      {types.length > 0 ? (
        <label className="block min-w-0 text-sm text-gray-700 dark:text-zinc-300">
          Issue type
          <select
            className={`mt-1 ${inputClass}`}
            value={issueType}
            onChange={(e) => {
              setIssueType(e.target.value);
              setPage(1);
            }}
          >
            <option value="">All issues</option>
            {types.map((t) => (
              <option key={t} value={t}>
                {qualityIssueLabel(t)}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      <p className="text-sm text-gray-600 dark:text-zinc-300">
        {filtered.length} unmatchable row{filtered.length === 1 ? "" : "s"}
        {issueType ? ` · ${qualityIssueLabel(issueType)}` : ""}.
      </p>
      <AudienceDataQualityIssues
        issues={filtered}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </div>
  );
}
